// tslint:disable
export var EnrollmentJobState;
(function (EnrollmentJobState) {
    // Running
    EnrollmentJobState[EnrollmentJobState["Running"] = 0] = "Running";
    // Complete
    EnrollmentJobState[EnrollmentJobState["Complete"] = 1] = "Complete";
    // Error
    EnrollmentJobState[EnrollmentJobState["Error"] = 2] = "Error";
})(EnrollmentJobState || (EnrollmentJobState = {}));
EnrollmentJobState['RUNNING'] = 0;
EnrollmentJobState['COMPLETE'] = 1;
EnrollmentJobState['ERROR'] = 2;
//# sourceMappingURL=EnrollmentJobState.js.map